const React = require("react");

function TrendingDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
  }));
}

module.exports = TrendingDownIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/TrendingDownIcon.js
 ** module id = 634
 ** module chunks = 0
 **/